import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase';

/**
 * Subscribe to users where facilityId == X. Returns a map of uid -> { name, role }
 * for the CoordinatorTable to resolve uid display names.
 */
export function useFacilityMembers(facilityId) {
    const [members, setMembers] = useState({});
    const [loading, setLoading] = useState(Boolean(facilityId));
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!facilityId) {
            setLoading(false);
            setMembers({});
            return undefined;
        }
        setLoading(true);
        setError(null);
        const q = query(collection(db, 'users'), where('facilityId', '==', facilityId));
        const unsubscribe = onSnapshot(
            q,
            (snap) => {
                const out = {};
                snap.forEach((d) => {
                    const data = d.data();
                    // No email: it moved to users/{uid}/private/profile (#307),
                    // which no client can read. Callers only label by name.
                    out[d.id] = {
                        name: data.name,
                        role: data.facilityRole,
                    };
                });
                setMembers(out);
                setLoading(false);
            },
            (err) => {
                setError(err);
                setLoading(false);
            },
        );
        return unsubscribe;
    }, [facilityId]);

    return { members, loading, error };
}
